import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=e781a3cc&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=ts&"
export * from "./gift.vue?vue&type=script&lang=ts&"
import style0 from "./gift.vue?vue&type=style&index=0&id=e781a3cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e781a3cc",
  null
  
)

export default component.exports